define('score_bootstrap/Models/Comments/CommentModel',[
    "jquery",
    "knockout"
], function ($, ko) {
    "use strict";

    function CommentModel(rootId, comment, maxCommentLength, renderLoadMore, allowedCascadedReplies, pageNumber, pageSize, totalPages, orderByAscending) {

        var self = this;

        self.rootId = rootId;
        self.allowedCascadedReplies = allowedCascadedReplies;
        self.maxCommentLength = maxCommentLength;
        self.pageNumber = ko.observable(pageNumber);
        self.pageSize = pageSize;
        self.orderByAscending = orderByAscending;
        self.totalPages = ko.observable(totalPages);
        self.showMoreEnabled = renderLoadMore;
        self.id = ko.observable(comment.Id);
        self.commentText = ko.observable(comment.CommentText);
        self.newCommentText = ko.observable('');
        self.createDate = ko.observable(comment.CreateDate || null);
        self.editDate = ko.observable(comment.EditDate || null);
        self.displayName = ko.observable(comment.DisplayName || null);
        self.removeDate = ko.observable(comment.RemoveDate || null);
        self.additionalUserInfo = ko.observable(comment.AdditionalUserInfo || null);
        self.isCommentOwner = ko.observable(comment.IsCommentOwner || false);
        self.isEdited = ko.observable(comment.IsEdited || false);
        self.isRemoved = ko.observable(comment.IsRemoved || false);
        self.isRestored = ko.observable(comment.IsRestored || false);
        self.removedByAdmin = ko.observable(comment.RemovedByAdmin);
        self.replies = ko.observableArray();
        self.canReply = ko.observable(allowedCascadedReplies > 0);
        self.isInFocus = ko.observable(false);

        self.canShowMore = ko.pureComputed(function () {
            return self.showMoreEnabled ? self.pageNumber() < self.totalPages() : false;
        }, self);

        self.showEditComment = ko.observable(false);
        self.focusEditComment = ko.pureComputed({
            read: function () {
                return self.showEditComment();
            },
            write: function (value) {
                self.showEditComment(value);                
            },
            owner: self
        }, self).extend({ throttle: 200 });
        self.editComment = function () {            
            self.showEditComment(true);
            if (!self.focusEditComment()) {
                self.focusEditComment(true);
            }
        };
        self.newCommentLength = ko.pureComputed(function () {
            return self.newCommentText() ? self.maxCommentLength - self.newCommentText().length : self.maxCommentLength;
        }, self);
        self.newCommentTooLong = ko.pureComputed(function () {
            var state = self.newCommentLength() < 0;
            
            if (state) {
                self.submitButtonEnabled(false);
            } else {
                self.submitButtonEnabled(self.newCommentLength() !== self.maxCommentLength);
            }

            return state;
        }, self);
        
        this.submitButtonEnabled = ko.observable(true);

        if (comment.Replies && (self.allowedCascadedReplies > 0)) {
            var nextLevelAllowedCascadedReplies = self.allowedCascadedReplies - 1;
            comment.Replies.forEach(function (item) {
                if (this.orderByAscending && !this.showMoreEnabled) {
                    this.replies.unshift(new CommentModel(self.id(),
                        item,
                        self.maxCommentLength,
                        false,
                        nextLevelAllowedCascadedReplies,
                        self.pageNumber(),
                        self.pageSize,
                        self.totalPages(),
                        self.orderByAscending));
                } else {
                    this.replies.push(new CommentModel(self.id(),
                        item,
                        self.maxCommentLength,
                        false,
                        nextLevelAllowedCascadedReplies,
                        self.pageNumber(),
                        self.pageSize,
                        self.totalPages(),
                        self.orderByAscending));
                }
                
            }, self);
        }

        // this stops collapsing text area in IE since IE triggers blur event after clicking on disabled button
        this.stopCollapsingIETextAreaOnDisabledButtonClick = function () {
            if (!self.submitButtonEnabled()) {
                self.focusEditComment(true);
                $(".score-reply-area").focus();
            }
        }
    };

    return CommentModel;
});
